export { ProductDetailsNutritionData } from './ProductDetailsNutritionData';
